/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/lib/wait-for-swiper.js"
/*!***************************************!*\
  !*** ./src/js/lib/wait-for-swiper.js ***!
  \***************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   waitForSwiper: () => (/* binding */ waitForSwiper)
/* harmony export */ });
/**
 * Wait until vendor-swiper.js has exposed window.Swiper (+ optional modules).
 * @param {string[]} [modules=[]] - Required SwiperModules keys, e.g. ['Autoplay']
 * @param {number} [maxAttempts=100]
 * @returns {Promise<boolean>}
 */
function waitForSwiper() {
  var modules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var maxAttempts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return new Promise(function (resolve) {
    var attempts = 0;
    var _check = function check() {
      var swiperReady = Boolean(window.Swiper);
      var modulesReady = modules.every(function (name) {
        var _window$SwiperModules;
        return (_window$SwiperModules = window.SwiperModules) === null || _window$SwiperModules === void 0 ? void 0 : _window$SwiperModules[name];
      });
      if (swiperReady && modulesReady) {
        resolve(true);
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        resolve(false);
        return;
      }
      setTimeout(_check, 50);
    };
    _check();
  });
}

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	const __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		const cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		const module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			const e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter/value functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			if(Array.isArray(definition)) {
/******/ 				var i = 0;
/******/ 				while(i < definition.length) {
/******/ 					var key = definition[i++];
/******/ 					var binding = definition[i++];
/******/ 					if(!__webpack_require__.o(exports, key)) {
/******/ 						if(binding === 0) {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, value: definition[i++] });
/******/ 						} else {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, get: binding });
/******/ 						}
/******/ 					} else if(binding === 0) { i++; }
/******/ 				}
/******/ 			} else {
/******/ 				for(var key in definition) {
/******/ 					if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 						Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
let __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/*!************************************!*\
  !*** ./src/js/zone3-statsslide.js ***!
  \************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initStatsSlides: () => (/* binding */ initStatsSlides)
/* harmony export */ });
/* harmony import */ var _lib_wait_for_swiper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/wait-for-swiper.js */ "./src/js/lib/wait-for-swiper.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function getDirectWrapper(el) {
  if (!el) return null;
  return Array.from(el.children).find(function (child) {
    var _child$classList;
    return (_child$classList = child.classList) === null || _child$classList === void 0 ? void 0 : _child$classList.contains('swiper-wrapper');
  }) || null;
}
function initStatsSlides() {
  return _initStatsSlides.apply(this, arguments);
}
function _initStatsSlides() {
  _initStatsSlides = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var ready, Swiper, statsSlideSections;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return (0,_lib_wait_for_swiper_js__WEBPACK_IMPORTED_MODULE_0__.waitForSwiper)();
        case 1:
          ready = _context.v;
          if (ready) {
            _context.n = 2;
            break;
          }
          return _context.a(2, null);
        case 2:
          Swiper = window.Swiper;
          statsSlideSections = document.querySelectorAll('.zone3__stats-slides');
          statsSlideSections.forEach(function (section) {
            var _pillSlides$;
            var linksWrapper = section.querySelector('.zone3__stats-slides__container--links');
            var statsSlide = section.querySelector('.zone3__stats-slides__container');
            var productsWrapper = section.querySelector('.zone3__stats-slides__container--products');
            if (!linksWrapper || !statsSlide) return;
            var pillSlides = linksWrapper.querySelectorAll('.swiper-slide');
            if (pillSlides.length === 0) return;

            // Main slides live in the direct child wrapper
            var mainWrapper = getDirectWrapper(statsSlide);
            var mainSlideCount = mainWrapper ? mainWrapper.querySelectorAll(':scope > .swiper-slide').length : 0;
            var loopEnabled = mainSlideCount > 1;
            var swiperLinks = new Swiper(linksWrapper, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              centeredSlides: true,
              breakpoints: {
                768: {
                  centeredSlides: false,
                  spaceBetween: 32
                }
              }
            });
            var productsMainWrapper = getDirectWrapper(productsWrapper);
            var productGroupSlides = productsMainWrapper ? productsMainWrapper.querySelectorAll(':scope > .swiper-slide') : [];
            var hasProducts = productGroupSlides.length > 0;
            var setActiveProductGroup = function setActiveProductGroup(index) {
              productGroupSlides.forEach(function (slide, i) {
                var isActive = i === index;
                slide.classList.toggle('is-active', isActive);
                slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
              });
            };
            var swiperProducts = hasProducts ? new Swiper(productsWrapper, {
              slidesPerView: 1,
              spaceBetween: 0,
              allowTouchMove: false,
              watchOverflow: true,
              on: {
                slideChange: function slideChange() {
                  setActiveProductGroup(this.activeIndex);
                }
              }
            }) : null;
            var nestedProductCarousels = [];
            if (hasProducts) {
              productsWrapper.querySelectorAll('.zone3__stats-slides__products-carousel').forEach(function (carousel) {
                var nestedWrapper = getDirectWrapper(carousel);
                var nestedCount = nestedWrapper ? nestedWrapper.querySelectorAll(':scope > .swiper-slide').length : 0;
                if (!nestedCount) return;
                nestedProductCarousels.push(new Swiper(carousel, {
                  slidesPerView: 1.1,
                  spaceBetween: 12,
                  nested: true,
                  grabCursor: true,
                  allowTouchMove: true,
                  watchOverflow: true,
                  breakpoints: {
                    600: {
                      slidesPerView: 1.5,
                      spaceBetween: 16
                    },
                    769: {
                      slidesPerView: 2.5
                    },
                    1280: {
                      slidesPerView: 3.5
                    }
                  }
                }));
              });
            }
            var syncToIndex = function syncToIndex(index) {
              swiperLinks.slideTo(index);
              swiperProducts === null || swiperProducts === void 0 || swiperProducts.slideTo(index, 0);
              setActiveProductGroup(index);

              // Fractional slidesPerView peeks bleed between groups; reset inactive carousels
              // so the next visit always starts clean.
              nestedProductCarousels.forEach(function (nestedSwiper, nestedIndex) {
                if (nestedIndex === index) return;
                nestedSwiper.slideTo(0, 0);
              });
            };
            var swiper = new Swiper(statsSlide, {
              slidesPerView: 1,
              grabCursor: true,
              allowTouchMove: true,
              loop: loopEnabled,
              autoHeight: true,
              on: {
                slideChange: function slideChange() {
                  var index = this.realIndex;
                  pillSlides.forEach(function (pill, i) {
                    var btn = pill.querySelector('.btn');
                    if (i === index) {
                      btn === null || btn === void 0 || btn.classList.add('btn--primary');
                    } else {
                      btn === null || btn === void 0 || btn.classList.remove('btn--primary');
                    }
                  });
                  syncToIndex(index);
                }
              }
            });
            var firstBtn = (_pillSlides$ = pillSlides[0]) === null || _pillSlides$ === void 0 ? void 0 : _pillSlides$.querySelector('.btn');
            firstBtn === null || firstBtn === void 0 || firstBtn.classList.remove('btn--ocean');
            firstBtn === null || firstBtn === void 0 || firstBtn.classList.add('btn--sky');
            pillSlides.forEach(function (slide, index) {
              slide.addEventListener('click', function () {
                if (loopEnabled) {
                  swiper.slideToLoop(index);
                } else {
                  swiper.slideTo(index);
                }
              });
            });
            syncToIndex(swiper.realIndex);
          });
          return _context.a(2, true);
      }
    }, _callee);
  }));
  return _initStatsSlides.apply(this, arguments);
}
document.addEventListener('DOMContentLoaded', function () {
  initStatsSlides();
});
})();

/******/ })()
;
//# sourceMappingURL=zone3-statsslide.js.map